module.exports = __webpack_public_path__ + "static/media/bkst_site_movies_header.46f40f31.jpg";